import {useEffect, useState} from 'react'
import PageHead from '../Head'
import BackToTop from '../backToTop'
import Spinner from '@/components/Spinner'
import styles from './marketplace.module.scss'
import Separator from '@/components/Common/Separator'
import MobileMenu from '@/components/Header/MobileMenu'
import Pagination from '@/components/Common/Pagination'
import { GET_ALL_ACTIVE_STORE, GET_STORE_ITEM_CATEGORIES } from '@/graphql/querries/store'
import FooterThree from '@/components/Footer/Footer-Three'
import CategoryMarket from '@/components/Category/CategoryMarket'
import HeaderStyleNine from '@/components/Header/HeaderStyle-Nine'
import MarketFilter from '@/components/Category/Filter/MarketFilter'
import HeaderStyleFive from '@/components/Header/Headers/HeaderStyle-FIve'
import { useQuery } from '@apollo/client'

const Market = () => {
  const [courses, setCourse] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  
  const { data: AllStore, loading } = useQuery(GET_ALL_ACTIVE_STORE, {
    variables: {
      paginationArgs: {
        pageSize: 20,
        pageNumber: page,
      },
    },
  });

  
  return (
    <>
      <PageHead title='' /> 
      <MobileMenu />
      <HeaderStyleFive />
      <CategoryMarket stores={AllStore?.getActiveStoreItems} />
      <div className="rbt-section-overlayping-top rbt-section-gapBottom">
        <div className="inner">
          <div className="container">
            {loading ? (
              <Spinner />
            ) : (
              <MarketFilter StoreItem={ AllStore?.getActiveStoreItems } />
            )}

            <div className="row">
              <div className="col-lg-12 mt--60">
                <Pagination pageNumber={page} setPage={setPage} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <BackToTop />
      <Separator />
      <FooterThree />
    </>
  )
}

export default Market